import { useSyncExternalStore } from 'react';
import { fmt, num } from './format.js';

/*
 * The "just happened" line under the card on Home (Saif, 21 Oct 2026 evening): one short line for this visit only, after
 * a top-up ("+£20 added") or a collection ("+49 points from today's order"). It lives in memory, so a cold start clears
 * it; a tab change or a resume keeps it.
 */

let note: string | null = null;
const listeners = new Set<() => void>();
const subscribe = (fn: () => void) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export function noteJustHappened(text: string | null): void {
  note = text;
  for (const fn of listeners) fn();
}
export const clearJustHappened = (): void => noteJustHappened(null);

export function useJustHappened(): string | null {
  return useSyncExternalStore(subscribe, () => note, () => null);
}

/** The lines, from the server's numbers. */
export const topupHappened = (pence: number): string => `+${fmt(pence)} added`;
export const collectHappened = (points: number, number?: number): string => (points > 0 ? `+${num(points)} points from today's order${number ? ` #${number}` : ''}` : `Order${number ? ` #${number}` : ''} collected`);

/** For tests: what the line holds right now. */
export const peekJustHappened = (): string | null => note;
